document.addEventListener('alpine:init', (e) => {
  Alpine.data('SubscriptionWidget', () => ({
    cache: {},
    purchaseOption: "one-time",
    current_variant: null,
    price_modifier: '',
    selling_plans: [],
    selling_plan: '',
    form_id: '',
    flags: {
      is_Onetime: true
    },
    init() {
      this.InitSelf();
      this.MoveWidget();
      this.InitWatchers();
      this.$nextTick(this.UpdateSellingPlans.bind(this));
    },
    InitWatchers() {
      let am = this;
      am.$watch('purchaseOption', () => {
        am.flags.is_Onetime = am.purchaseOption == 'one-time';
        am.UpdatePrice();
        am.UpdateSellingPlans();
      });

      am.$watch('selling_plan', am.UpdateSellingPlans.bind(am));

      document.addEventListener('shapes:product:variantchange', (e) => {
        // console.log(e)
        am.current_variant = e.detail.variant;
        am.UpdatePrice();
      });
      am.$nextTick(am.UpdatePrice.bind(am));
    },
    InitSelf() {
      let am = this;
      am.cache.$product_wrap = document.querySelector('.product-block-container');
      am.cache.$addtocart_button_container = am.cache.$product_wrap.querySelector('.product-block-buy-buttons');
      am.cache.$product_price = am.cache.$product_wrap.querySelectorAll('[data-product-price]');
      am.cache.$product_form = am.cache.$product_wrap.querySelector('form[action="/cart/add"]');
      am.form_id = am.cache.$product_form.getAttribute('id');

      am.selling_plans = JSON.parse(am.$el.dataset.sellingPlans);
      am.selling_plan = am.selling_plans[0].id;

      am.current_variant = JSON.parse(am.$el.dataset.currentVariant);
      am.price_modifier = JSON.parse(am.$el.dataset.priceModifier);
    },
    MoveWidget() {
      let am = this;
      let $previous_widget = am.cache.$product_wrap.querySelector('[id*="shopify-block-bold_subscriptions_bsub_widget"]');
      if ($previous_widget) {
        $previous_widget.remove();
      }
      am.cache.$addtocart_button_container.insertAdjacentElement('beforebegin', am.$el);
      am.UpdatePrice();
    },
    UpdatePrice() {
      let am = this;
      am.cache.$product_price.forEach(($price) => {
        // console.log(am.flags.is_Onetime, am.$el.querySelector('.price-one-time'))
        $price.textContent = am.flags.is_Onetime ?
          am.$el.querySelector('.price-one-time').textContent :
          am.$el.querySelector('.price-subscription').textContent;
      });
    },
UpdateSellingPlans() {
      let am = this;
      
      // Update the selling plan input
      am.cache.$product_wrap.querySelectorAll('[name="selling_plan"]').forEach(($sp) => {
        if (am.flags.is_Onetime) {
          $sp.value = '';  // Clear the selling plan value for one-time purchase
        } else {
          $sp.value = am.selling_plan;  // Set the selling plan for subscription
        }
      });
    },
    FormatMoney(value) {
      return formatMoney(value);
    }
  }));      
});
